import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import myImg from "../../Assets/avatar.svg";
import myImg from "../../Assets/profile-pic3.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LAISSEZ MOI ME <span className="purple"> PRÉSENTER </span>
            </h1>
            <p className="home-about-body">
              Laissez-moi me présenter. Je suis un développeur full-stack passionné par l'informatique et j'ai acquis de nombreuses compétences dans divers domaines, que ce soit en DevOps, développement web, applications mobiles, base de données et réseaux.
              <br />
              <br />Je maîtrise les classiques comme le
              <i>
                <b className="purple"> C, Python, Java et JavaScript. </b>
              </i>
              <br />
              <br />
              Mes domaines d'intérêt sont &nbsp;
              <i>
                <b className="purple">la création de nouvelles technologies et produits Web </b> ainsi que {" "}
                <b className="purple">
                  l'Algorithmie
                </b>
              </i>
              <br />
              <br />
              J'applique ma passion pour le développement de produits avec <b className="purple">Node.js</b> et
              <i>
                <b className="purple">
                  {" "}
                  les frameworks JavaScript modernes comme
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js et Angular</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>TROUVEZ-MOI SUR</h1>
            <p>
              N'hésitez pas à me <span className="purple">suivre </span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/UnMecLambda"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href=""
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/thierno-bangoura-126434137/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/1mec_lambda"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
